import { TrainerPaymentState } from './types';

export const state = (): TrainerPaymentState => initialState();

export const initialState = (): TrainerPaymentState => ({
  trainerPayments: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name', 'departmentName', 'costCenter'],
    },
  },
});
